import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear tokens from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');

    // Redirect to the login page
    navigate('/login');
  }, [navigate]);

  return (
    <div>
      <p>Logging you out...</p>
    </div>
  );
};

export default Logout;
